const pagesSettingsSettingsEn = {
  sso: {
    active: 'Enabled',
    addConnection: 'Add Connection',
    card: {
      domains: 'Target domains',
      providers: 'Inbound SSO',
      status: 'Status'
    },
    deleteDialog: {
      cancelButton: 'Cancel',
      deleteButton: 'Disconnect',
      description: 'Domain settings will also be removed, and affected users will no longer be able to sign in via SSO',
      title: 'Disconnect this provider?'
    },
    description: "Let users sign in to DRESS CODE with your organization's identity provider",
    disconnect: 'Disconnect',
    edit: 'Edit',
    editDialog: {
      addDomain: 'Add domain',
      cancelButton: 'Cancel',
      domainPlaceholder: 'e.g. acme.com',
      domainsDescription: 'Specify the email domains for users who will sign in via SSO',
      domainsLabel: 'Target domains',
      enabledLabel: 'Enabled',
      removeDomainAriaLabel: 'Remove {{domain}}',
      saveButton: 'Save',
      title: 'Inbound SSO: {{provider}}',
      titleConnect: 'Add Connection: {{provider}}'
    },
    loadError: 'Could not load',
    noDomains: 'Not configured',
    notConnected: 'Not Connected',
    openMenu: 'Open menu',
    paused: 'Paused',
    retry: 'Retry',
    title: 'Inbound SSO',
    toast: {
      deleteSuccess: 'Provider disconnected',
      saveSuccess: 'SSO connection saved'
    },
    validation: {
      duplicateDomain: 'This domain is already added',
      invalidDomain: 'Please enter a valid domain format',
      issuerIdentifierRequired: 'This field is required'
    }
  }
};
export default pagesSettingsSettingsEn;